/*
 * NOTE: This is an auto-generated file created by Iconic.
 *
 * You should not need to edit this file directly; if you need to add/remove any
 * icon modules, you can rebuild it by running `yarn icons:make`.
 */
import * as React from 'react'

import VacasaWrapper from '../Wrapper'

const VacasaMessageSquare: React.FunctionComponent = () => {
  return (
    <VacasaWrapper id="messageSquare" viewBox="0 0 16 16">
      <path
        d="M4.19537 10.862C4.32071 10.7367 4.49004 10.6667 4.66671 10.6667H12.6667C13.0347 10.6667 13.3334 10.368 13.3334 10V3.33337C13.3334 2.96537 13.0347 2.66671 12.6667 2.66671H3.33337C2.96537 2.66671 2.66671 2.96537 2.66671 3.33337V12.3907L4.19537 10.862ZM4.94271 12L2.47137 14.4714C2.05137 14.8914 1.33337 14.594 1.33337 14V3.33337C1.33337 2.22871 2.22871 1.33337 3.33337 1.33337H12.6667C13.7714 1.33337 14.6667 2.22871 14.6667 3.33337V10C14.6667 11.1047 13.7714 12 12.6667 12H4.94271Z"
        fill="#FBFBFC"
      ></path>
    </VacasaWrapper>
  )
}

export default React.memo(VacasaMessageSquare)
